import { useHistory } from "react-router-dom";
import {useTranslation} from "react-i18next";
import useQueryState from "../../../hooks/useQueryState";
import {useSelector} from "react-redux";
import {HseContextSelector} from "../../../reducers/hseCurrentContext";
import {NAVBAR_TAB_NAMES} from "../const/navbarTabNames";
import { CreateExternalLinkTo } from "shared/constants/linkTo";

export const useGetBrndTabs = (onCloseMenu?: () => void) => {

    const history = useHistory();
    const { t, i18n: { language } } = useTranslation();
    const [{ tab } ] = useQueryState();
    const { onSetTab } = useSelector(HseContextSelector);
    
    return {
    [NAVBAR_TAB_NAMES.brnd_shop]: {
        active: tab === 'shop',
        content: t(`nav.shop`),
        linkTo: CreateExternalLinkTo.shopBrands(`?page=1&lang=${language}&team=161ed0e49efb4bf0b03e81cb09638606%2Ce2718ce5065749a09c9ab1dd801efd68`)
    },
    [NAVBAR_TAB_NAMES.brnd_brands]: {
        active: window.location.href.includes('brands'),
        content: t(`nav.brands`),
        action: (ev: any) => {
            onSetTab && onSetTab('brands');
            history.push('/brands')
            onCloseMenu && onCloseMenu();
        }
    },
    [NAVBAR_TAB_NAMES.brnd_startup_incubator]: {
        active: window.location.href.includes('startups'),
        content: t(`nav.startup_incubator`),
        action: (ev: any) => {
            onSetTab && onSetTab('startups');
            history.push(`/startups`);
            onCloseMenu && onCloseMenu();
        }
    },
    [NAVBAR_TAB_NAMES.brnd_courses]: {
        active: window.location.href.includes('/lms'),
        content: t(`nav.education`),
        action: (ev: any) => {
            onSetTab && onSetTab('/lms');
            history.push(`/lms`);
            onCloseMenu && onCloseMenu();
        }
    },
    [NAVBAR_TAB_NAMES.brnd_ideas]: {
        active: window.location.href.includes('ideas'),
        content: t(`nav.ideas`),
        action: (ev: any) => {
            onSetTab && onSetTab('ideas');
            history.push(`/ideas`);
            onCloseMenu && onCloseMenu();
        }
    },
    [NAVBAR_TAB_NAMES.brnd_about]: {
        content: t(`nav.about`),
        linkTo: '/about'
    },
    }
}import { useHistory } from "react-router-dom";
import {useTranslation} from "react-i18next";
import useQueryState from "../../../hooks/useQueryState";
import {useSelector} from "react-redux";
import {HseContextSelector} from "../../../reducers/hseCurrentContext";
import {NAVBAR_TAB_NAMES} from "../const/navbarTabNames";
import { CreateExternalLinkTo } from "shared/constants/linkTo";

export const useGetBrndTabs = (onCloseMenu?: () => void) => {

    const history = useHistory();
    const { t, i18n: { language } } = useTranslation();
    const [{ tab } ] = useQueryState();
    const { onSetTab } = useSelector(HseContextSelector);
    
    return {
    [NAVBAR_TAB_NAMES.brnd_shop]: {
        active: tab === 'shop',
        content: t(`nav.shop`),
        linkTo: CreateExternalLinkTo.shopBrands(`?page=1&lang=${language}&team=161ed0e49efb4bf0b03e81cb09638606%2Ce2718ce5065749a09c9ab1dd801efd68`)
    },
    [NAVBAR_TAB_NAMES.brnd_brands]: {
        active: window.location.href.includes('brands'),
        content: t(`nav.brands`),
        action: (ev: any) => {
            onSetTab && onSetTab('brands');
            history.push('/brands')
            onCloseMenu && onCloseMenu();
        }
    },
    [NAVBAR_TAB_NAMES.brnd_startup_incubator]: {
        active: window.location.href.includes('startups'),
        content: t(`nav.startup_incubator`),
        action: (ev: any) => {
            onSetTab && onSetTab('startups');
            history.push(`/startups`);
            onCloseMenu && onCloseMenu();
        }
    },
    [NAVBAR_TAB_NAMES.brnd_courses]: {
        active: window.location.href.includes('/lms'),
        content: t(`nav.education`),
        action: (ev: any) => {
            onSetTab && onSetTab('/lms');
            history.push(`/lms`);
            onCloseMenu && onCloseMenu();
        }
    },
    [NAVBAR_TAB_NAMES.brnd_ideas]: {
        active: window.location.href.includes('ideas'),
        content: t(`nav.ideas`),
        action: (ev: any) => {
            onSetTab && onSetTab('ideas');
            history.push(`/ideas`);
            onCloseMenu && onCloseMenu();
        }
    },
    [NAVBAR_TAB_NAMES.brnd_about]: {
        content: t(`nav.about`),
        linkTo: '/about'
    },
    }
}